export const KEY_CODES = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  BACKSPACE: 8,
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  I: 73,
};
